import { themeObject } from 'lib';

export const chainSelectorStyle = {
    mainBoxStyle: {
        mb: 3,
        display: 'flex',
        justifyContent: 'center',
    },
    displayFlex: {
        dsiplay: 'flex',
        width: '100%',
    },
    nestedBoxStyle: { textAlign: 'center', p: 3, mt: 6 },
    imgStyle: {
        display: 'inline-block',
        width: '286.53px',
        height: '162.6px',
        margin: '0 auto',
    },
    typoStyle: {
        textAlign: 'center',
        color: themeObject.palette.grayScale[700],
        fontSize: '26px',
    },
    textAlignCenter: {
        display: 'flex',
        justifyContent: 'center',
        textAlign: 'center',
    },
    chainAutocomplete: {
        width: '400px',
        minHeight: '32px',
        '& .MuiSelect-icon': {
            color: themeObject.palette.primary.dark,
        },
        '& .MuiFormControl-root': {
            width: '100%',
            '& .MuiTextField-root': {
                '& .MuiInputBase-root': {
                    height: '32px',
                    pr: '50px',
                    '& .MuiInputBase-input': {
                        height: '100%',
                    },
                },
            },
        },
    },
};
